import { Button } from '@lt/components';
import { useTranslation } from '@lt/localization';
import React from 'react';
import { LoginFormType } from 'src/components/AuthNew/types';
import type { SimpleInterpolation } from 'styled-components';
import classnames from 'classnames';
import styles from './switchFormButtons.module.css';

type Props = {
  loginFormType: LoginFormType;
  setLoginFormType: (formtype: LoginFormType) => void;
  loginFormCSS?: ReadonlyArray<SimpleInterpolation>;
};

export const SwitchFormButtons = ({
  loginFormType,
  setLoginFormType,
  loginFormCSS,
}: Props) => {
  const { t } = useTranslation();

  let value = '';

  if (
    loginFormCSS &&
    loginFormCSS.length > 0 &&
    loginFormCSS[0] !== null &&
    loginFormCSS[0] !== undefined
  ) {
    const str = loginFormCSS[0] as string;
    value = str.split(':')[1].trim().replace(';', '');
  }

  return (
    <div className={styles.btnWrapper}>
      <Button
        className={classnames(styles.phoneButton, {
          [styles.activeButton]: loginFormType === LoginFormType.Phone,
        })}
        style={{
          '--background': value,
        }}
        $formType={loginFormType}
        $loginFormCSS={loginFormCSS}
        onClick={() => setLoginFormType(LoginFormType.Phone)}
      >
        {t('checkout.loginForm.switchFormButtons.phone')}
      </Button>
      <Button
        className={classnames(styles.emailButton, {
          [styles.activeButton]: loginFormType === LoginFormType.Email,
        })}
        style={{
          '--background': value,
        }}
        $formType={loginFormType}
        onClick={() => setLoginFormType(LoginFormType.Email)}
      >
        {t('checkout.loginForm.switchFormButtons.email')}
      </Button>
    </div>
  );
};
